module.exports = __webpack_public_path__ + "static/media/created-by-idBForge_grey.7dcd354a.svg";